/* eslint-disable i18next/no-literal-string */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { XGrid } from 'app/components/Common/XGrid/XGrid';
import { XGridDefaultColumn } from 'app/components/Common/XGrid/cells/XGridDefaults';
import { XGridOverflowCell } from 'app/components/Common/XGrid/cells/XGridOverflowCell';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { XGridChipCell } from 'app/components/Common/XGrid/cells/XGridChipCell';
import { GridCellParams } from '@mui/x-data-grid-pro';
import { useDispatch, useSelector } from 'react-redux';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Box, Checkbox, FormControlLabel, List, ListItem, ListItemText, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { selectUser } from 'oidc/user.selectors';
import { userRoles } from 'oidc/userRoles';
import { GenericDialog } from 'app/components/Alerts/GenericDialog';
import {
  selectPlacementHeaderData,
  selectPlacementLandsGtgDetails,
} from '../../../../../../store/redux-store/placement-details/selectors';
import { postFinalizedByQs } from 'app/services/PlacementServices/PlacementServices';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { placementEventActions } from '../CredentialingTab/Store/PlacementEventDetails.redux';
import { placementDetailsAction } from '../../../../../../store/redux-store/placement-details/slice';
import { PassportXGridOptionsCell } from './PassportXGridOptionsCell';
import { Authorized } from 'oidc/userHelper';
import { useTranslation } from 'react-i18next';
// import ReasonInfo from 'app/assets/images/CandidateHeader/info.svg';
// import { CustomTooltip } from 'app/components/Common/Tooltips';

const useStyles = makeStyles()(() => ({
  qsCheckbox: {
    marginRight: 0,
    height: 0,
    fontWeight: 500,
  },
  menuItem: {
    padding: 2,
    '&:hover': {
      backgroundColor: '#fff',
    },
  },
}));

export const PassportCredentialXGrid = props => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const [sortModel] = React.useState<any>([]);
  const user = useSelector(selectUser);
  const placementDetails = useSelector(selectPlacementHeaderData);
  const landsGtgDetails = useSelector(selectPlacementLandsGtgDetails);
  const [credentials, setCredentials] = useState<any[]>(props.credentials);
  const [columns, setColumns] = React.useState<any>([]);
  const [finalizedByQs, setFinalizedByQs] = useState<any>(false);
  const [showAlert, setShowAlert] = useState<any>(false);
  const isLandsGtgCompleted = landsGtgDetails?.isgtgComplete && landsGtgDetails?.isLandsComplete;

  React.useEffect(() => {
    setColumns(getDefaults());
  }, []);

  React.useEffect(() => {
    setFinalizedByQs(placementDetails.isFinalizedByQS);
  }, [placementDetails]);

  const resetColumns = () => {
    setColumns(getDefaults());
  };

  const checkAccessPermission = () => {
    return Authorized(
      [userRoles.credentialing_Leadership, userRoles.credentialing_TeamMember],
      user.userInfo,
    );
  };

  const MenuItems = props => {
    return (
      <>
        <List style={{ padding: 0 }}>
          {props.rowMetaData.row.exceptionWaiveType === '--' && !props.rowMetaData.row.RequirementTypeId ? (
            <ListItem
              button
              className={classes.menuItem}
              disabled={!checkAccessPermission()}
              onClick={event => {
                dispatch(placementEventActions.setExceptionWaive(null));
                dispatch(placementEventActions.setExceptionWaveNewAttachment(null));
                dispatch(placementEventActions.setDeletedAttachment(null));
                dispatch(
                  placementEventActions.setExceptionDialogState({
                    credential: props.rowMetaData?.row,
                    open: true,
                    add: true,
                    edit: false,
                  }),
                );
              }}
            >
              <ListItemText
                primary={t('placement.profile.tabs.passportCredentialXGrid.addExceptionWaive')}
                primaryTypographyProps={{
                  variant: 'body2',
                }}
                style={{ color: '#555555', fontSize: '12px' }}
              />
            </ListItem>
          ) : (
            <React.Fragment>
              <ListItem
                className={classes.menuItem}
                button
                onClick={event => {
                  dispatch(placementEventActions.setExceptionWaive(null));
                  dispatch(placementEventActions.setExceptionWaveNewAttachment(null));
                  dispatch(placementEventActions.setDeletedAttachment(null));
                  dispatch(
                    placementEventActions.setExceptionDialogState({
                      credential: props.rowMetaData?.row,
                      open: true,
                      add: false,
                      edit: false,
                    }),
                  );
                }}
              >
                <ListItemText
                  primary={t('placement.profile.tabs.passportCredentialXGrid.viewExceptionWaive')}
                  primaryTypographyProps={{
                    variant: 'body2',
                  }}
                  style={{ color: '#555555', fontSize: '12px' }}
                />
              </ListItem>
              <ListItem
                className={classes.menuItem}
                button
                onClick={event => {
                  dispatch(placementEventActions.setExceptionWaive(null));
                  dispatch(placementEventActions.setExceptionWaveNewAttachment(null));
                  dispatch(placementEventActions.setDeletedAttachment(null));
                  dispatch(
                    placementEventActions.setExceptionDialogState({
                      credential: props.rowMetaData?.row,
                      open: true,
                      add: false,
                      edit: true,
                    }),
                  );
                }}
              >
                <ListItemText
                  primary={t('placement.profile.tabs.passportCredentialXGrid.editExceptionWaive')}
                  primaryTypographyProps={{
                    variant: 'body2',
                  }}
                  style={{ color: '#555555', fontSize: '12px' }}
                />
              </ListItem>
            </React.Fragment>
          )}
        </List>
      </>
    );
  };

  const MenuAMIEClassic = props => {
    return (
      <>
        <Box component="span" style={{ color: '#333333', opacity: 1 }}>
          {t('placement.profile.tabs.passportCredentialXGrid.featureAvailableAMIEClassic')}
        </Box>
      </>
    );
  };

  const getColumnDefinition = (t, key) => {
    return {
      ...XGridDefaultColumn,
      field: key,
      headerName: t(`placement.profile.tabs.passportCredentialXGrid.columns.${key}`),
    };
  };

  const getDefaults = () => {
    return [
      {
        ...XGridDefaultColumn,
        field: 'exceptionWaiveId',
        disableColumnMenu: true,
        sortable: false,
        hide: true,
      },
      {
        ...getColumnDefinition(t, 'category'),
        renderCell: XGridOverflowCell()(),
      },
      {
        ...getColumnDefinition(t, 'requirementFullDescription'),
        renderCell: XGridOverflowCell()(),
      },
      {
        ...getColumnDefinition(t, 'status'),
        renderCell: XGridChipCell({
          size: 'small',
          dynamicColor: (params: GridCellParams) => {
            return getColor(params.value);
          },
        }),
      },
      {
        ...getColumnDefinition(t, 'exceptionWaiveType'),
        renderCell: XGridOverflowCell()(),
      },
      {
        ...getColumnDefinition(t, 'actions'),
        flex: 0,
        width: 50,
        sortable: false,
        align: 'center',
        disableColumnMenu: true,
        renderCell: PassportXGridOptionsCell({
          icon: <MoreVertIcon style={{ color: '#8E9195' }} />,
          align: 'center',
          hoverTemplate: (params: GridCellParams | undefined) => {
            if (params?.row.status !== 'Compliant') {
              return params?.row?.requirementTypeId ? <MenuItems rowMetaData={params} /> : <MenuAMIEClassic />;
            }
            return null;
          },
        }),
      },
    ];
  };

  useEffect(() => {
    setCredentials(props.credentials);
  }, [props.credentials]);

  const getColor = (status: any) => {
    switch (status) {
      case 'Not Compliant':
        return '#CB0813';
      case 'Compliant':
        return '#5FB661';
      default:
        return '#000000';
    }
  };

  const handleConfirmAction = async () => {
    var postBody = {
      placementId: placementDetails.placementId,
      isFinalizedByQS: !finalizedByQs,
      finalizedByUserId: user.userInfo?.employeeId || 8410,
    };
    const response = await postFinalizedByQs(postBody);
    setFinalizedByQs(!finalizedByQs);
    setShowAlert(false);
    if (response?.status == 200 || response?.status == 204) {
      dispatch(
        globalActions.setSnackBar({
          message: t('placement.profile.tabs.passportCredentialXGrid.confirmActionSucessMessage'),
          severity: 'success',
        }),
      );
      dispatch(placementDetailsAction.setIsFinalisedByQs(response?.data?.isFinalizedByQS));
    } else {
      dispatch(
        globalActions.setSnackBar({
          message: t('placement.profile.tabs.passportCredentialXGrid.confirmActionErrorMessage'),
          severity: 'error',
        }),
      );
    }
  };

  const SearchXGrid = React.useMemo(() => {
    return (
      <XGrid
        title={t('placement.profile.tabs.passportCredentialXGrid.title')}
        columns={columns}
        rows={credentials}
        loading={false}
        toolbarProps={{
          resetColumns,
          leftActions: [
            {
              tooltipProps: {
                tooltipContent: t('placement.profile.tabs.passportCredentialXGrid.completeLandsGtgHoverText'),
                disabled: isLandsGtgCompleted,
              },
              renderer: () => (
                <FormControlLabel
                  style={{ marginBottom: '3px' }}
                  control={
                    <Checkbox
                      disableFocusRipple
                      disableRipple
                      disableTouchRipple
                      checked={finalizedByQs}
                      disabled={!checkAccessPermission() || !isLandsGtgCompleted}
                      onChange={event => setShowAlert(true)}
                      color="primary"
                    />
                  }
                  className={classes.qsCheckbox}
                  label={
                    <Typography style={{ opacity: isLandsGtgCompleted ? '1' : '0.5', marginRight: '10px' }}>
                      {t('placement.profile.tabs.passportCredentialXGrid.finalizedByQS')}
                    </Typography>
                  }
                />
              ),
            },
          ],
        }}
        /*actionItems={[
          <FormControlLabel
            control={
              <Checkbox
                disableFocusRipple
                disableRipple
                disableTouchRipple
                checked={finalizedByQs}
                disabled={!checkAccessPermission() || !isLandsGtgCompleted}
                onChange={event => setShowAlert(true)}
                color="primary"
              />
            }
            className={classes.qsCheckbox}
            label={
              <Typography style={{ opacity: isLandsGtgCompleted ? '1' : '0.5', marginRight: '10px' }}>
                {t('placement.profile.tabs.passportCredentialXGrid.finalizedByQS')}
              </Typography>
            }
          />,
          !isLandsGtgCompleted ? (
            <CustomTooltip
              interactive
              arrow
              standardMargin
              tooltipContent={
                <Typography component="div" style={{ width: '185px', fontSize: '14px' }}>
                  {t('placement.profile.tabs.passportCredentialXGrid.completeLandsGtgHoverText')}
                </Typography>
              }
              placement="bottom-end"
            >
              <img src={ReasonInfo} alt="Reason information" style={{ marginTop: '5px' }} />
            </CustomTooltip>
          ) : (
            <></>
          ),
        ]}*/
        sortModel={sortModel}
        checkboxSelection
      />
    );
  }, [credentials, columns, sortModel, setShowAlert, showAlert]);

  return (
    <LayoutGrid>
      <LayoutGridItem xs={12}>{SearchXGrid}</LayoutGridItem>
      <GenericDialog
        open={showAlert}
        disableEscapeKeyDown
        maxWidth="sm"
        fullWidth
        dialogTitleProps={{
          style: { paddingTop: '20px' },
          text: finalizedByQs
            ? t('placement.profile.tabs.passportCredentialXGrid.confirmDialog.finalizedByQsTrueMessage')
            : t('placement.profile.tabs.passportCredentialXGrid.confirmDialog.finalizedByQsFalseMessage'),
        }}
        onClose={(e, reason) => {
          if (reason === 'backdropClick') return;
          setShowAlert(false);
        }}
        dialogActions={[
          {
            text: t('placement.profile.tabs.passportCredentialXGrid.confirmDialog.cancelBtn'),
            variant: 'contained',
            color: 'tertiary',
            onClick: () => setShowAlert(false),
          },
          {
            text: t('placement.profile.tabs.passportCredentialXGrid.confirmDialog.confirmBtn'),
            variant: 'contained',

            color: 'primary',
            onClick: () => handleConfirmAction(),
          },
        ]}
      >
        <span>
          {finalizedByQs
            ? t('placement.profile.tabs.passportCredentialXGrid.finalizedByQsTrueMessage')
            : t('placement.profile.tabs.passportCredentialXGrid.finalizedByQsFalseMessage')}
        </span>
      </GenericDialog>
    </LayoutGrid>
  );
};
